import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { GiRadarSweep } from 'react-icons/gi';

import { Text, Heading, Box, Icon } from 'core/components';
import { addCommas } from 'app/util/utils';
import CreditUsageIndicator from 'app/views/synthetics/tests/CreditUsageIndicator';

import LabelValue from './LabelValue';
import { PlanCardContainer, PlanCardLeftFlex, PlanCardMainContentWrapper, PlanIconBox } from './v2/layout';
import FreeTrialCallout from './v2/FreeTrialCallout';

@observer
class SyntheticsPlanCard extends Component {
  render() {
    const {
      id,
      name,
      description: planDescription,
      free_credits,
      paid_credits,
      cloud_provider,
      trialDaysRemaining,
      usedSyntheticCredits,
      creditsToEom,
      full_retention,
      openContactAccountTeamDialog,
      ...rest
    } = this.props;

    const showPlanDescription = !cloud_provider;
    const isFreeTrialPlan = name === 'Free Trial Plan';
    const icon = <Icon icon={GiRadarSweep} iconSize={40} color="primary" />;
    const max_credits = (parseInt(free_credits, 10) || 0) + (parseInt(paid_credits, 10) || 0);

    return (
      <PlanCardContainer {...rest}>
        <PlanCardLeftFlex>
          {icon && <PlanIconBox>{icon}</PlanIconBox>}

          <PlanCardMainContentWrapper>
            <Text color="muted" as="div" mb="4px">
              Synthetics
            </Text>

            <Heading level={4} mb={1}>
              {name}{' '}
              <Text fontWeight={200} muted>
                ({id})
              </Text>
            </Heading>

            {showPlanDescription && (
              <Text color="muted" as="div" mb={1}>
                {planDescription}
              </Text>
            )}

            <Box mt="4px">
              <CreditUsageIndicator
                totalAvailableCredits={max_credits}
                usedCredits={usedSyntheticCredits}
                pendingTestUsage={creditsToEom}
              />
            </Box>

            {isFreeTrialPlan && <FreeTrialCallout trialDaysRemaining={trialDaysRemaining} />}
          </PlanCardMainContentWrapper>
        </PlanCardLeftFlex>
        <Box>
          <LabelValue label="Used Credits" value={addCommas(parseInt(usedSyntheticCredits))} />
          <LabelValue label="Max Credits" value={addCommas(parseInt(max_credits))} />
          <LabelValue label="Data Retention" value={`${full_retention} days`} mb={0} />
        </Box>
      </PlanCardContainer>
    );
  }
}

export default SyntheticsPlanCard;
